const flattenCkeditorFields = (node) => {
  if (Array.isArray(node)) return node.map(flattenCkeditorFields)
  if (node && typeof node === 'object') {
    const keys = Object.keys(node)
    if (keys.length === 1 && keys[0] === 'html') return node.html
    const out = {}
    for (const k of keys) out[k] = flattenCkeditorFields(node[k])
    return out
  }
  return node
}

const queryServerSideData = async (queryPath, variables = {}, cookies = '') => {
  const apiUrl = process.env.NEXT_PUBLIC_CRAFTCMS_API
  const query = queryPath.includes('.graphql')
    ? require(`../../queries/${queryPath}`)
    : require(`../../queries/${queryPath}`).default

  const queryData = {
    query,
    variables
  }

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      cookie: cookies
    },
    body: JSON.stringify(queryData)
  }

  let json = false
  const res = await fetch(apiUrl, opts)

  if (res.ok) {
    json = await res.json()
    if (json?.data) json.data = flattenCkeditorFields(json.data)
  } else {
    json = { error: true, status: res.status, message: res.statusText }
  }

  return json
}

export default queryServerSideData
